import React from 'react';

export function Field({ label, children, error }: { label: string; children: React.ReactNode; error?: string }): React.ReactElement {
  return (
    <div className="mb-[18px]">
      <label className="mb-1.5 block text-small font-bold" style={{ color: "#0A0F0F" }}>{label}</label>
      {children}
      {error && <div className="mt-1 text-tiny" style={{ color: "#D9453C" }}>{error}</div>}
    </div>
  );
}
